<template>
  <div class="devMenu">
    <p>Developer ONLY functions</p>
    <div class="devBtn">
      <LocalizationBtn id="langBtn" label="locBtnLabel" :route="route" />
      <button @click="this.$store.commit('clearCART')">clear cart</button>
      <button v-if="$route.name != 'Rework'">
        <router-link to="{name:Rework}">Data Rework</router-link>
      </button>
      <button v-if="$route.name != 'Compare'">
        <router-link to="{name:Compare}">Data Compare</router-link>
      </button>
      <button v-if="$route.name != 'Copy'">
        <router-link to="{name:Copy}">Data Copy</router-link>
      </button>
      <button v-if="$route.name != 'About'">
        <router-link to="/{name:About}">About</router-link>
      </button>
    </div>
  </div>
</template>

<script>
import LocalizationBtn from "@/components/localization-dropdown.vue";

export default {
  name: "devMenu",
  props: {
    route: String,
  },
  components: {
    LocalizationBtn,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
  updated() {},
};
</script>

<style scoped>
.devMenu {
  display: flex;
  flex-direction: column;
  justify-content: start;
  padding-bottom: 50px;
}

.devBtn {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
